import { render, staticRenderFns } from "./TaskDetailPageHeader.vue?vue&type=template&id=1a7fc157"
import script from "./TaskDetailPageHeader.vue?vue&type=script&lang=js"
export * from "./TaskDetailPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports